export enum EnumTriviaStatesOfGame {
	loading = 'loading',
	before_game = 'before_game',
	in_game = 'in_game',
	contest_break = 'contest_break',
	after_round = 'after_round',
	end_game = 'end_game',
}

export enum EnumInGameState {
	unknown = 'unknown',
	warning = 'warning',
	question = 'question',
	set_questions = 'set_questions',
	set_questions_result = 'set_questions_result',
	fun_fact = 'fun_fact',
}

export enum EnumAfterRoundState {
	unknown = 'unknown',
	wager = 'wager',
	normal = 'normal',
}

export enum EnumTriviaAnswerType {
	multiple_choice = 'multiple_choice',
	binary = 'binary',
	free_response = 'free_response',
	multi_select = 'multi_select'
}

export enum EnumTriviaContestStatus {
	scheduled = 'scheduled',
	live = 'live',
	complete = 'complete',
	voided = 'voided',
}

export enum EnumTriviaStatusType {
	scheduled = 'scheduled',
	live = 'live',
	complete = 'complete',
}

export enum EnumTriviaRoundType {
	normal = 'normal',
	speed = 'speed',
	rapid_fire_2 = 'rapid_fire_2',
	this_or_that = 'this_or_that',
	right_right_wrong = 'right_right_wrong',
	wager = 'wager'
}

export enum EnumFooterTickerState {
	count_users,
	pre_game,
	after_game
}

export enum EnumFooterRightSideState {
	sponsor = 'sponsor',
	timer = 'timer',
	round_name = 'round_name',
	round_card = 'round_card',
	none = 'none',
}

export enum EnumFooterMsgState {
	round_sponsor = 'round_sponsor',
	contest_sponsor = 'contest_sponsor',
	none = 'none',
}

export enum EnumTriviaContestType {
	lunchtime = 'lunchtime',
	happy_hour = 'happy_hour',
	late_night = 'late_night',
	team_night = 'team_night',
}

export enum EnumAnswerStates {
	correct = 'correct',
	incorrect = 'incorrect',
	selected = 'selected',
	unknown = 'unknown',
}

export enum PubNubActions {
	join = 'join',
	timeout = 'timeout',
	leave = 'leave',
	state_change = 'state-change'
}

export enum EnumSponsors {
	Heineken = 'heineken',
	Michelob = 'michelob_ultra_dulce_vida',
	LongBranch = 'longbranch',
	DosEquis = 'dos_equis',
	LightSky = 'light_sky',
}

export enum EnumTriviaLadders {
	contest = 'contest',
	contest_by_state = 'contest_state',
	contest_by_store = 'contest_store',

	month = 'month',
	month_by_state = 'month_state',
	month_by_store = 'month_store',

	round = 'round',
	round_by_store = 'round_store',
	round_by_state = 'round_state',

	overall = 'overall',
	overall_by_store = 'overall_store',
	overall_by_state = 'overall_state',

	team_season = 'team_season',
	team_season_state = 'team_season_state',
	team_season_store = 'team_season_store',

	team_month = 'team_month',
	team_month_by_state = 'team_month_state',
	team_month_by_store = 'team_month_store',

	team_contest = 'team_contest',
	team_contest_by_state = 'team_contest_state',
	team_contest_by_store = 'team_contest_store',

	team_round = 'team_round',
	team_round_by_store = 'team_round_store',
	team_round_by_state = 'team_round_state',


}

export enum EnumPointsPrize {
	'Prize_1000'='1000' ,
	'Prize_500'  = '500' ,
	'Prize_200' = '200' ,
	'Prize_100' = '100' ,
	'Prize_25' = '25',
}

export enum EnumMonthlyPrizesTypes {
	Top100 = 'top100',
	Top50 = 'top50',
	Top25 = 'top25',
	Monthly = 'monthly',
}

export enum EnumMonthlyPrizesPPTypes {
	Top100 = 'top100',
	Top25 = 'top25',
	Monthly = 'monthly',
}

export enum EnumRegion {
	East = 'east',
	West = 'west',
}

export enum EnumTriviaStatsContestType {
	hardest_question = 'hardest_question',
	easiest_question = 'easiest_question',
	hardest_round = 'hardest_round',
	easiest_round = 'easiest_round',
}

export enum EnumEventGame {
	PicksAndProps = 'picksandprops',
	Trivia = 'trivia',
	AO = 'trivia_always_on'
}

export enum EnumScreenState {
	Active = 'active',
	Prev = 'prev',
	Next = 'next'
}

export enum EnumHerdStatus {
	Active = 'active',
	Expired = 'expired',
}

export enum EnumOrders {
	Asc = 'ASC',
	Desc = 'DESC'
}

export enum EnumLadderFilter {
	Contest = 'contest',
	State = 'state',
	Store = 'store',
	Season = 'season'
}
